export const stats = [
  { label: '收录番号', value: '128,560', suffix: '+', icon: 'ri-database-2-line' },
  { label: '分类数量', value: '8', suffix: ' 大类', icon: 'ri-folder-line' },
  { label: '日更新量', value: '200', suffix: '+', icon: 'ri-refresh-line' },
  { label: '累计用户', value: '500,000', suffix: '+', icon: 'ri-user-line' },
];